import { create } from 'zustand';

export interface StagedDoc {
  id: string;
  docTypeId: string;
  docTypeName: string;
  file: File;
}

interface PermitFormStore {
  openSection: string;
  completedSections: string[];
  stagedDocs: StagedDoc[];
  docsError: string | null;
  addDocOpen: boolean;
  setOpenSection: (id: string) => void;
  addCompletedSection: (id: string) => void;
  setCompletedSections: (sections: string[]) => void;
  addStagedDoc: (doc: StagedDoc) => void;
  removeStagedDoc: (id: string) => void;
  setDocsError: (e: string | null) => void;
  setAddDocOpen: (open: boolean) => void;
  reset: () => void;
}

const initialState = {
  openSection: 'account',
  completedSections: [] as string[],
  stagedDocs: [] as StagedDoc[],
  docsError: null as string | null,
  addDocOpen: false,
};

export const usePermitFormStore = create<PermitFormStore>((set) => ({
  ...initialState,
  setOpenSection: (id) => set({ openSection: id }),
  addCompletedSection: (id) =>
    set((s) => ({
      completedSections: s.completedSections.includes(id)
        ? s.completedSections
        : [...s.completedSections, id],
    })),
  setCompletedSections: (sections) => set({ completedSections: sections }),
  addStagedDoc: (doc) => set((s) => ({ stagedDocs: [...s.stagedDocs, doc] })),
  removeStagedDoc: (id) => set((s) => ({ stagedDocs: s.stagedDocs.filter((d) => d.id !== id) })),
  setDocsError: (e) => set({ docsError: e }),
  setAddDocOpen: (open) => set({ addDocOpen: open }),
  reset: () => set({ ...initialState }),
}));
